import { GeneralStatus } from 'modules/status-badge';
import { handleApiError } from 'utils/api';
import { env } from '../../constants';
import { WeekDetailsResponse } from './types';

export const WEEKS_DETAILS_API_URL = 'weeks/details';

const getWeekDetailsApiUrl = (calendarWeek: number, year: number): string =>
  `${WEEKS_DETAILS_API_URL}?calendarWeek=${calendarWeek}&year=${year}&orderBy=shiftStart&orderDirection=DESC`;

export const fetchWeek = async (
  token: string | undefined,
  calendarWeek: number | undefined,
  year: number | undefined
): Promise<WeekDetailsResponse | undefined> => {
  if (!token || !calendarWeek || !year) {
    return undefined;
  }

  const response = await fetch(
    `${env.VITE_API_BASE_URL}/${getWeekDetailsApiUrl(calendarWeek, year)}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
    }
    return undefined;
  }

  return response.json() as Promise<WeekDetailsResponse>;
};

export const updateWeekStatus = async (
  token: string | undefined,
  weekId: string | undefined
): Promise<null | undefined> => {
  if (!token || !weekId) {
    return undefined;
  }

  const response = await fetch(`${env.VITE_API_BASE_URL}/weeks/${weekId}`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ weekStatus: GeneralStatus.CLOSED })
  });

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
    }
    if (response.status === 400) {
      await handleApiError(response);
    } else throw Error('Could not update week status');
  }

  return null;
};
